/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brmodrf2Inputs */



/**
* | output |
* | --- |
* | "RF modulation" |
*
* @param {Brmodrf2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const brmodrf2 = /** @type {((inputs?: Brmodrf2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brmodrf2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("RF modulation")
	return /** @type {LocalizedString} */ ("Modulation RF")
});
export { brmodrf2 as "brModRf" }